import axios from 'axios'
import { PRICE_VERSION_VARIATION_DRAFT_BY_DEPRECIATION } from '../../endpoints'

export async function getDraftByDepreciation({id, year, value}){
    try{
        let depreciation = Number(value.replace(',','.'))
        const response = await axios.get(`${PRICE_VERSION_VARIATION_DRAFT_BY_DEPRECIATION}/${id}?year=${year}&depreciation=${depreciation}`).then(result=>result.data);
        return {
            dataForTable: response.data,
            yearsForTable: response.years,
            modelVersionPrice: response.modelVersionPrice
        }
    }catch(error){
        throw new Error(error)
    }
}